import React from 'react';
import { Box, Divider, Heading as HeadingChakra } from '@chakra-ui/react';

interface HeadingProps {
  title: string;
}

const Heading: React.FC<HeadingProps> = ({ title }) => {
  return (
    <>
      <HeadingChakra
        as="h3"
        mt={10}
        fontSize={['xl', '2xl', '3xl']}
        color="brand.primary"
      >
        {title}
      </HeadingChakra>
      <Divider mb={5} mt={5} />
      <Box mt={10} />
    </>
  );
};

export default Heading;
